import React, {useEffect, useState} from 'react';

import Auth from '../index';
import Password from '../../common/FormFields/Password';
import Button from '../../common/FormFields/Button';
import queryString from 'query-string';
import {withRouter} from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { verifyPasswordResetCode, getAuth } from 'firebase/auth';
import Loader from '../../common/Loader';
import { checkExternalUrlAccess } from '../../../services/helpers';

const RestorePassword = (props) => {
  const { resetPasswordRequest, forgotPasswordError, location, clearAuthValidationErrors } = props;
  const [newPassword, setNewPassword] = useState('');
  const [isOobCodeValid, setIsOobCodeValid] = useState(null);
  const [blockedUrls, setBlockedUrls] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    clearAuthValidationErrors();

    const checkOobCode = async () => {
      const blocked = await checkExternalUrlAccess();
      if (blocked.length > 0) {
        setBlockedUrls(blocked);
        setIsOobCodeValid(false);
        return;
      }

      const { oobCode } = queryString.parse(location.search);
      try {
        await verifyPasswordResetCode(getAuth(), oobCode);
        setIsOobCodeValid(true);
      } catch (error) {
        setIsOobCodeValid(false);
      }
    };

    checkOobCode();
  }, [clearAuthValidationErrors, location])


  const handleSubmit = (e) => {
    e.preventDefault();
    const { oobCode } = queryString.parse(location.search);
    resetPasswordRequest({ verificationCode: oobCode, newPassword });
  };

  if (isOobCodeValid === null) {
    return <Loader className="is-fixed" />;
  }

  return (
    isOobCodeValid ?
    <Auth>
      <div className="modal">
        <form action="/" className="form auth-form">
          <h1 className="auth-title-2">{t('auth.createNewPassword')}</h1>
          <div className="auth-body">
            <Password
              placeholder={t('auth.enterNewPassword')}
              label={t('auth.newPassword')}
              onChangeValue={setNewPassword}
              errorMessage={forgotPasswordError}
            />
          </div>
          <div className="auth-footer">
            <Button
              btnClassName="btn-primary"
              text={t('auth.confirm')}
              onClick={handleSubmit}
              disabled={!newPassword}
            />
          </div>
        </form>
      </div>
    </Auth>
    : <div className='modal-container'>
        <div className='modal'>
          {blockedUrls ? (
            <>
              <div className='modal-header'>
                <h1 className='modal-title'>{t('auth.firewallErrorTitle')}</h1>
              </div>
              <div className='modal-content'>
                <p className='modal-msg' style={{ textAlign: 'left' }}>{t('auth.firewallError')}</p>
                <ul style={{ listStyle: 'disc', paddingLeft: 35, margin: '10px 0 0' }}>
                  {blockedUrls.map((url) => (
                    <li key={url} style={{ fontWeight: 400, lineHeight: 1.6 }}>{url.replace(/^https?:\/\//, '')}</li>
                  ))}
                </ul>
              </div>
            </>
          ) : (
            <>
              <h1 className='modal-title'>{t('auth.expiredPasswordResetLinkModal.header')}</h1>
              <p className='modal-content'>{t('auth.expiredPasswordResetLinkModal.body')}</p>
            </>
          )}
        </div>
      </div>
  );
};

export default withRouter(RestorePassword);
